"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WebChatScreen = WebChatScreen;
var _inputGroup = require("@design/ui/input-group");
var _webChat = require("./web-chat.wiring");
var _jsxRuntime = require("react/jsx-runtime");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function WebChatScreen() {
  var _w$greetingGreeting, _w$inputGroupContent, _w$inputGroupAddonSlo;
  var w = (0, _webChat.useWiring)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      gap: "32px",
      justifyContent: "center",
      alignItems: "center",
      padding: "0px 16px 0px 16px",
      alignSelf: "stretch"
    },
    "data-sentry-component": "WebChatScreen",
    "data-sentry-source-file": "web-chat.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: {
        display: "flex",
        flexDirection: "column",
        gap: "32px",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        flexGrow: "1",
        flexBasis: "0",
        minHeight: "0",
        maxWidth: "768px"
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          alignSelf: "stretch"
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            alignSelf: "stretch",
            color: "rgba(10, 10, 10, 1)",
            fontFamily: "Lora",
            fontSize: "36px",
            fontWeight: "400",
            lineHeight: "40px",
            letterSpacing: "-0.9px",
            textAlign: "center"
          },
          children: (_w$greetingGreeting = w.greetingGreeting) !== null && _w$greetingGreeting !== void 0 ? _w$greetingGreeting : "How can I help you, Laurie?"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          justifyContent: "flex-end",
          alignItems: "center",
          alignSelf: "stretch"
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_inputGroup.InputGroup, _objectSpread(_objectSpread({}, w.inputGroup), {}, {
          className: "h-auto flex-col",
          "data-sentry-element": "InputGroup",
          "data-sentry-source-file": "web-chat.tsx",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              alignItems: "flex-start",
              alignSelf: "stretch"
            },
            children: (_w$inputGroupContent = w.inputGroupContent) !== null && _w$inputGroupContent !== void 0 ? _w$inputGroupContent : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_inputGroup.InputGroupTextarea, _objectSpread(_objectSpread({}, w.inputGroupInput), {}, {
                placeholder: "What would you like to know?"
              })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_inputGroup.InputGroupAddon, _objectSpread(_objectSpread({}, w.inputGroupAddon), {}, {
                align: "inline-end",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  style: {
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    alignItems: "center",
                    flexGrow: "1",
                    flexBasis: "0",
                    minWidth: "0",
                    alignSelf: "stretch"
                  },
                  children: (_w$inputGroupAddonSlo = w.inputGroupAddonSlot) !== null && _w$inputGroupAddonSlo !== void 0 ? _w$inputGroupAddonSlo : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                      src: "data:image/svg+xml,%3Csvg%20width%3D%2236%22%20height%3D%2236%22%20viewBox%3D%220%200%2036%2036%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20clip-path%3D%22url(%23clip0_0_344)%22%3E%0A%3Cg%20opacity%3D%220.5%22%3E%0A%3Cmask%20id%3D%22mask0_0_344%22%20style%3D%22mask-type%3Aalpha%22%20maskUnits%3D%22userSpaceOnUse%22%20x%3D%2210%22%20y%3D%2210%22%20width%3D%2216%22%20height%3D%2216%22%3E%0A%3Crect%20x%3D%2210%22%20y%3D%2210%22%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22%23D9D9D9%22%2F%3E%0A%3C%2Fmask%3E%0A%3Cg%20mask%3D%22url(%23mask0_0_344)%22%3E%0A%3Cpath%20d%3D%22M17.5778%2023.163C17.4642%2023.0494%2017.4074%2022.9086%2017.4074%2022.7407V18.5926H13.2593C13.0914%2018.5926%2012.9506%2018.5358%2012.8371%2018.4222C12.7235%2018.3086%2012.6667%2018.1679%2012.6667%2018C12.6667%2017.8321%2012.7235%2017.6914%2012.8371%2017.5778C12.9506%2017.4642%2013.0914%2017.4074%2013.2593%2017.4074H17.4074V13.2593C17.4074%2013.0914%2017.4642%2012.9506%2017.5778%2012.837C17.6914%2012.7235%2017.8321%2012.6667%2018%2012.6667C18.1679%2012.6667%2018.3087%2012.7235%2018.4222%2012.837C18.5358%2012.9506%2018.5926%2013.0914%2018.5926%2013.2593V17.4074H22.7408C22.9087%2017.4074%2023.0494%2017.4642%2023.163%2017.5778C23.2766%2017.6914%2023.3334%2017.8321%2023.3334%2018C23.3334%2018.1679%2023.2766%2018.3086%2023.163%2018.4222C23.0494%2018.5358%2022.9087%2018.5926%2022.7408%2018.5926H18.5926V22.7407C18.5926%2022.9086%2018.5358%2023.0494%2018.4222%2023.163C18.3087%2023.2765%2018.1679%2023.3333%2018%2023.3333C17.8321%2023.3333%2017.6914%2023.2765%2017.5778%2023.163Z%22%20fill%3D%22%233F3C38%22%2F%3E%0A%3C%2Fg%3E%0A%3C%2Fg%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3CclipPath%20id%3D%22clip0_0_344%22%3E%0A%3Crect%20width%3D%2236%22%20height%3D%2236%22%20fill%3D%22white%22%2F%3E%0A%3C%2FclipPath%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E",
                      alt: "Leading",
                      style: {
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center"
                      }
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                      style: {
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "flex-start",
                        flexGrow: "1",
                        flexBasis: "0",
                        minWidth: "0",
                        height: "1px"
                      }
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                      src: "data:image/svg+xml,%3Csvg%20width%3D%2236%22%20height%3D%2236%22%20viewBox%3D%220%200%2036%2036%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20opacity%3D%220.5%22%3E%0A%3Cpath%20d%3D%22M0%208C0%203.58172%203.58172%200%208%200H28C32.4183%200%2036%203.58172%2036%208V28C36%2032.4183%2032.4183%2036%2028%2036H8C3.58172%2036%200%2032.4183%200%2028V8Z%22%20fill%3D%22%23293EAD%22%2F%3E%0A%3Cpath%20d%3D%22M16.7533%2019.2461C16.6513%2019.1444%2016.5299%2019.0643%2016.3962%2019.0108L12.1673%2017.315C12.1169%2017.2947%2012.0738%2017.2595%2012.0439%2017.2141C12.014%2017.1686%2011.9987%2017.1151%2012.0001%2017.0607C12.0015%2017.0063%2012.0195%2016.9537%2012.0517%2016.9098C12.0838%2016.8659%2012.1287%2016.833%2012.1801%2016.8153L22.3123%2013.3491C22.3596%2013.332%2022.4107%2013.3287%2022.4597%2013.3397C22.5088%2013.3506%2022.5537%2013.3753%2022.5892%2013.4108C22.6247%2013.4463%2022.6494%2013.4912%2022.6603%2013.5403C22.6713%2013.5893%2022.668%2013.6404%2022.6509%2013.6877L19.1847%2023.8199C19.167%2023.8713%2019.1341%2023.9161%2019.0902%2023.9483C19.0463%2023.9805%2018.9937%2023.9985%2018.9393%2023.9999C18.8849%2024.0013%2018.8314%2023.986%2018.7859%2023.9561C18.7405%2023.9262%2018.7053%2023.8831%2018.685%2023.8327L16.9892%2019.6027C16.9354%2019.4692%2016.8552%2019.3478%2016.7533%2019.2461ZM16.7533%2019.2461L22.5875%2013.4131%22%20stroke%3D%22%23F4F6FB%22%20stroke-width%3D%221.002%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3C%2Fg%3E%0A%3C%2Fsvg%3E",
                      alt: "Right Actions",
                      style: {
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center"
                      }
                    })]
                  })
                })
              }))]
            })
          })
        }))
      })]
    })
  });
}